import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Lightbox from '@components/Common/Lightbox';
import './InteriorSection.css';

const interiorImages = [
  { src: '/images/interior/hero-interior.jpg', title: 'Modern Bedroom' },
  { src: '/images/interior/bedroom-2.jpg', title: 'Luxury Bedroom' },
  { src: '/images/interior/bedroom-9.jpg', title: 'Contemporary Bedroom' },
  {
    src: '/images/interior/classic-interior-pune.jpg',
    title: 'Classic Interior at Pune',
  },
  {
    src: '/images/interior/entry-foyer-sarthana.jpg',
    title: 'Entry Foyer at Sarthana',
  },
  { src: '/images/interior/home-theatre.jpg', title: 'Home Theatre' },
  {
    src: '/images/interior/hospital-waiting.jpg',
    title: 'Hospital Waiting Area',
  },
  { src: '/images/interior/kitchen-3.jpg', title: 'Modern Kitchen' },
  { src: '/images/interior/living-room.jpg', title: 'Living Room' },
  { src: '/images/interior/office-2.jpg', title: 'Office Interior' },
];

const InteriorSection = () => {
  const [lbOpen, setLbOpen] = useState(false);
  const [lbIndex, setLbIndex] = useState(0);
  const lightboxImages = interiorImages.map((i) => i.src);

  return (
    <section className="interior-section">
      <div className="container">
        <h2 className="section-title">Interior Designs</h2>
      </div>

      <div className="swiper-container-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={3}
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          speed={900}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          className="interior-swiper"
        >
          {interiorImages.map((img, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="interior-slide"
                onClick={() => {
                  setLbIndex(idx);
                  setLbOpen(true);
                }}
              >
                <img src={img.src} alt={img.title} className="interior-image" />
                <div className="interior-overlay">
                  <h3 className="interior-title">{img.title}</h3>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {lbOpen && (
        <Lightbox
          images={lightboxImages}
          currentIndex={lbIndex}
          onClose={() => setLbOpen(false)}
        />
      )}
    </section>
  );
};

export default InteriorSection;
